module.exports = __webpack_public_path__ + "static/media/amenity_lobby-concierge.8f371b16.jpg";